/// <amd-module name="Test/FailedTestsMetricView/Stores/FailedTestsMetricStore" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { FailedTestsMetricActions } from "Test/FailedTestsMetricView/Actions/FailedTestsMetricActions";
import { Store } from "VSS/Reflux/Store";

export interface IFailedTestsMetricState {
    uniqueFailingTests?: number;
    totalFailedResults?: number;
    uniqueFlakyTests?: number;
}

export class FailedTestsMetricStore extends Store {
    private _state: IFailedTestsMetricState;

    constructor(private _actions: FailedTestsMetricActions) {
        super("");
        this._initialize();
    }

    public getState(): IFailedTestsMetricState {
        return this._state;
    }

    public dispose(): void {
        this._actions.updateConfigurationValuesAction.removeListener(this._onUpdateConfiguration);
        this._actions.updateFailedTestsMetricAction.removeListener(this._onUpdateFailedTestsMetric);
        this._actions.updateFlakyTestsMetricAction.removeListener(this._onUpdateFlakyTestsMetric);
    }

    private _initialize(): void {
        this._state = { uniqueFailingTests: undefined, totalFailedResults: undefined, uniqueFlakyTests: undefined } as IFailedTestsMetricState;
        this._actions.updateConfigurationValuesAction.addListener(this._onUpdateConfiguration);
        this._actions.updateFailedTestsMetricAction.addListener(this._onUpdateFailedTestsMetric);
        this._actions.updateFlakyTestsMetricAction.addListener(this._onUpdateFlakyTestsMetric)
    }

    private _onUpdateFailedTestsMetric = (failedTestsMetricData: CommonTypes.IFailedCardMetricData) => {
        this._state.uniqueFailingTests = failedTestsMetricData.totalFailingTestsCount;
        this._state.totalFailedResults = failedTestsMetricData.totalFailedResultsCount;
        this.emitChanged();
    };

    private _onUpdateFlakyTestsMetric = (flakyData: number) => {
        this._state.uniqueFlakyTests = flakyData;
        this.emitChanged();
    };

    private _onUpdateConfiguration = () => {
        this._state.uniqueFailingTests = undefined; // This is done since after config change it will take time for data to come and component can show loading experience till then.
        this._state.totalFailedResults = undefined;
        this._state.uniqueFlakyTests = undefined
        this.emitChanged();
    };
}
